import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowStatExpand = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 14,
	viewBox: "0 0 12 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0.693359 5.68164C0.439453 5.45312 0.439453 5.04688 0.667969 4.81836C0.896484 4.56445 1.30273 4.56445 1.53125 4.79297L5.97461 9.05859L10.4434 4.79297C10.6719 4.56445 11.0781 4.56445 11.3066 4.81836C11.5352 5.04688 11.5352 5.45312 11.2812 5.68164L6.40625 10.3535C6.2793 10.4551 6.12695 10.5312 5.97461 10.5312C5.84766 10.5312 5.69531 10.4551 5.56836 10.3535L0.693359 5.68164Z",
			fill: "#78909C"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 12,
			height: 1.5,
			rx: .75,
			transform: "matrix(1 0 0 -1 0 14)",
			fill: "#78909C"
		})
	]
});
const ForwardRef = forwardRef(SvgArrowStatExpand);
export { ForwardRef as ReactComponent };
